export default __webpack_public_path__ + "static/media/mon-gray.09404320.png";